module.exports = __webpack_public_path__ + "static/media/click2.fe0ded65.wav";